import { render, staticRenderFns } from "./DhmeBillOfMaterialGroups.vue?vue&type=template&id=6027eee5&scoped=true"
import script from "./DhmeBillOfMaterialGroups.vue?vue&type=script&lang=js"
export * from "./DhmeBillOfMaterialGroups.vue?vue&type=script&lang=js"
import style0 from "./DhmeBillOfMaterialGroups.vue?vue&type=style&index=0&id=6027eee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6027eee5",
  null
  
)

export default component.exports